/* eslint-disable react/no-array-index-key */
import React from 'react';

import { Heading, List, ListItem } from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { TaggedAccordion } from 'client/components/taggedAccordion/TaggedAccordion';
import testIds from 'client/testIds';

import { LimitedCompanyCriteriaContent } from '../LimitedCompanyCriteria.config';
import BackToTopLink from './BackToTopLink';

function CompanySection() {
  const { jumpToASection, backToTopLabel, company } =
    useContent<LimitedCompanyCriteriaContent>();

  const {
    id,
    title,
    companyStructure,
    directorsShareholders,
    applicationCriteria,
    tenancyCriteria,
    sourceOfDeposit,
  } = company;

  return (
    <section
      id={id}
      data-testid={testIds.limitedCompanyCriteria.companySection}
    >
      <Heading
        size="s5"
        marginBottom="05"
        marginTop="05"
        as="h2"
        dataTestId={testIds.limitedCompanyCriteria.companyHeading}
      >
        {title}
      </Heading>

      <TaggedAccordion
        label={companyStructure.title}
        id={companyStructure.id}
        variation="inpage1"
        dataTestId={testIds.limitedCompanyCriteria.companyStructure}
      >
        <List>
          {companyStructure.listItems.map((item, idx) => (
            <ListItem key={`company-structure-${idx}`}>{item}</ListItem>
          ))}
        </List>
      </TaggedAccordion>

      <TaggedAccordion
        label={directorsShareholders.title}
        id={directorsShareholders.id}
        variation="inpage1"
        dataTestId={testIds.limitedCompanyCriteria.directorsShareholders}
      >
        <List>
          {directorsShareholders.listItems.map((item, idx) => (
            <ListItem key={`directors-shareholders-${idx}`}>{item}</ListItem>
          ))}
        </List>
      </TaggedAccordion>

      <TaggedAccordion
        label={applicationCriteria.title}
        id={applicationCriteria.id}
        variation="inpage1"
        dataTestId={testIds.limitedCompanyCriteria.applicationCriteria}
      >
        <List>
          {applicationCriteria.listItems.map((item, idx) => (
            <ListItem key={`application-criteria-${idx}`}>{item}</ListItem>
          ))}
        </List>
      </TaggedAccordion>

      <TaggedAccordion
        label={tenancyCriteria.title}
        id={tenancyCriteria.id}
        variation="inpage1"
        dataTestId={testIds.limitedCompanyCriteria.tenancyCriteria}
      >
        <List>
          {tenancyCriteria.listItems.map((item, idx) => (
            <ListItem key={`tenancy-criteria-${idx}`}>{item}</ListItem>
          ))}
        </List>
      </TaggedAccordion>

      <TaggedAccordion
        label={sourceOfDeposit.title}
        id={sourceOfDeposit.id}
        variation="inpage1"
        dataTestId={testIds.limitedCompanyCriteria.sourceOfDeposit}
      >
        <List>
          {sourceOfDeposit.listItems.map((item, idx) => (
            <ListItem key={`source-of-deposit-${idx}`}>{item}</ListItem>
          ))}
        </List>
      </TaggedAccordion>

      <BackToTopLink
        dataTestId={`${id}-back-to-top`}
        jumpToASectionId={jumpToASection.id}
      >
        {backToTopLabel}
      </BackToTopLink>
    </section>
  );
}

export default CompanySection;
